import { Component, computed, input, output } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UploadStatus } from '@app/shared/types/enums/file-enums';
import { FileUploadInfo } from '@app/shared/types/models/files/file-upload-info';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { TranslatePipe } from '@ngx-translate/core';

/** Shared upload status presentation; the existing FileDataService owns requests and cancellation. */
@Component({
  selector: 'proffeo-file-upload-list',
  templateUrl: './file-upload-list.component.html',
  imports: [MatProgressBarModule, UiButtonComponent, TranslatePipe]
})
export class FileUploadListComponent {
  protected readonly UploadStatus = UploadStatus;
  protected readonly visibleUploads = computed(() =>
    this.uploads().filter(
      upload =>
        upload.status === UploadStatus.Started ||
        upload.status === UploadStatus.Failure ||
        upload.status === UploadStatus.Canceled
    )
  );
  public readonly uploads = input<FileUploadInfo[]>([]);
  public readonly cancelRequested = output<string | undefined>();
  public readonly dismiss = output<string | undefined>();

  protected onCancel(uploadId: string | undefined): void {
    this.cancelRequested.emit(uploadId);
  }

  protected onDismiss(uploadId: string | undefined): void {
    this.dismiss.emit(uploadId);
  }
}
